import App from './App.vue'
import Vant from 'vant'
import router from './router' //引入路由配置
import store from './store/store' //引入 Vuex 状态管理
import Vue from 'vue'
import { Toast } from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant)

Vue.use(Toast)
import { Circle } from 'vant';
Vue.use(Circle);


import { NavBar } from 'vant';
Vue.use(NavBar);

import { Button } from 'vant';
Vue.use(Button);

import { Uploader } from 'vant';

Vue.use(Uploader);

import { Empty } from 'vant';

Vue.use(Empty);

import { NoticeBar } from 'vant';

Vue.use(NoticeBar);

import vantGlobalLoading from '@/utils/vant-global-loading';

Vue.use(vantGlobalLoading);
new Vue({
    render: h => h(App),
    router, //使用路由配置
    store //使用 Vuex 进行状态管理
}).$mount('#app')

